import { createAction, props } from '@ngrx/store';

import { LookupProps, LookupState } from '../reducers/lookup.reducer';

const prefix = '[Lookup]';

export const genderlookupAction = createAction(
  `${prefix} gender`,
  props<{ data: LookupProps[]; isLoading: boolean }>()
);
export const stateLookupAction = createAction(
  `${prefix} states`,
  props<{ data: LookupProps[]; isLoading: boolean }>()
);
export const lgasLookupAction = createAction(
  `${prefix} lgas`,
  props<{ data: LookupProps[]; isLoading: boolean }>()
);
export const industriesLookupAction = createAction(
  `${prefix} industries`,
  props<{ data: LookupProps[]; isLoading: boolean }>()
);

export const setStateAction = createAction(
  `${prefix} set state`,
  props<Partial<LookupState>>()
);
